import { Button, Text } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { BrandLoader } from '@shared/ui/brand-loader';
import classes from './request-overlay.module.css';

type Props = {
  loading?: boolean;
  error?: string | boolean | null;
  onRetry?: () => unknown;
  page?: boolean;
  inFlow?: boolean;
  label?: string;
};

/** Shared loading/error layer. Page layers always leave the app header and dock accessible. */
export const RequestOverlay = ({ loading = false, error, onRetry, page = false, inFlow = false, label }: Props) => (
  <div
    className={classes.layer}
    data-page={page || undefined}
    data-in-flow={inFlow || undefined}
    role={loading ? 'status' : 'alert'}
    aria-busy={loading}
    aria-label={label ?? (loading ? 'Загружаем данные' : 'Ошибка загрузки')}
  >
    <div className={classes.controls}>
      <BrandLoader size={loading ? 64 : 56} active={loading} />
      {!loading && (
        <>
          <Text className={classes.message} ta="center">
            {typeof error === 'string' ? error : 'Не удалось загрузить данные.'}
          </Text>
          {onRetry && (
            <Button
              variant="game"
              rightSection={<IconRefresh size={19} aria-hidden="true" />}
              onClick={() => {
                void onRetry();
              }}
            >
              Повторить
            </Button>
          )}
        </>
      )}
    </div>
  </div>
);
